define('modules/signup/resetpassword/model',['require','exports','module','app','env','base/model'],function(require, exports, module) {
    "use strict";

    var app = require("app");
    var Config = require("env");
    var BaseModel = require("base/model");

    var Model = BaseModel.extend({
        idAttribute: '_ticket',
        urlRoot : '/ticket',
        initialize: function() {
            this.initRequestEvents();
        },
        url: function() {
            var url = Config.backendUrl + "/reset-password";
            if (this.id) {
                url += "/"+this.id;
            }            
            return url;
        }
        
    });

    module.exports = Model;
});
